import { useTranslation } from 'react-i18next';
import { reclaimSession } from '../net/socket';
import { useSession } from '../stores/session';
import { Button, Spinner } from './Button';
import s from './ui.module.css';

export function ConnectionBanner() {
  const { t } = useTranslation();
  const status = useSession((x) => x.status);
  if (status === 'reconnecting' || status === 'connecting') {
    return (
      <div className={s.banner} data-testid="conn-banner">
        <Spinner /> {t(status === 'connecting' ? 'conn.connecting' : 'conn.reconnecting')}
      </div>
    );
  }
  if (status === 'replaced') {
    return (
      <div className={s.banner}>
        {t('conn.replaced')}
        <Button size="small" variant="primary" onClick={reclaimSession}>
          {t('conn.useHere')}
        </Button>
      </div>
    );
  }
  if (status === 'upgrade') {
    return (
      <div className={s.banner}>
        {t('conn.upgrade')}
        <Button size="small" variant="primary" onClick={() => window.location.reload()}>
          {t('conn.reload')}
        </Button>
      </div>
    );
  }
  return null;
}
